class TokenService {
  getLocalRefreshToken() {
    const user = JSON.parse(localStorage.getItem('user'));
    return user?.refresh_token;
  }

  getLocalAccessToken() {
    const user = JSON.parse(localStorage.getItem('user'));
    return user?.access_token;
  }

  // The refresh answer carries no login; the mnemonic check still needs it.
  updateLocalToken(token) {
    const user = JSON.parse(localStorage.getItem('user'));
    localStorage.setItem('user', JSON.stringify({ ...token, login: token.login || user?.login }));
  }
}

export default new TokenService();
